import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { useBreakpoint } from '../../styles/breakpoints';
import { Headline4 } from './Text';
import { FlexboxVertical } from './Layout';

const StyledNavigation = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: stretch;
`;

const SideNavigationBackground = styled.div`
  position: absolute;
  top: 7.5px;
  left: 7.5px;
  right: 0;
  bottom: 0;
  background-color: ${Colors.secondary};
  z-index: 1;
`;

export const SiteNavigationContent = styled(FlexboxVertical)<Props>`
  border: none;
  background-color: ${({ whiteBackground }) => whiteBackground ? Colors.white : Colors.background};
  color: ${Colors.grayDark};
  z-index: 2;
  margin: 0 7.5px 7.5px 0;
  flex: 1;
  list-style: none;
  position:relative;
  min-width: 18rem;
  padding: .75rem 1rem;
  
  ${Headline4} {
    margin-bottom: 1.5rem;
  }
  
  ${useBreakpoint('l')} {
    padding: 1rem 1.5rem;
  }
`;

interface Props {
  headline?: string;
  whiteBackground?: boolean;
}
export const SiteNavigationBox: FC<Props> = (props) => {
  const { whiteBackground = false, headline } = props;

  return (
    <StyledNavigation>
      <SideNavigationBackground/>
      <SiteNavigationContent {...props}>
        {
          headline &&
          <Headline4>{ headline }</Headline4>
        }
        {
          props.children
        }
      </SiteNavigationContent>
    </StyledNavigation>
  );
};
